import {RouteConfig} from 'vue-router'
import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

// Pages
import Login from 'src/pages/Login.vue'
import NotFound from 'src/pages/NotFound.vue'
import AccessDenied from 'src/pages/AccessDenied.vue'

import notifications from './routes/notifications'
import settings from './routes/settings'
import grades from './routes/grades'
import resp from './routes/resp'
import sched from './routes/sched'
import wiki from './routes/wiki'
import messenger from './routes/messeger'

// @ts-ignore
import messages from '@/lang/index'

const loginPage: RouteConfig = {
  path: '/login/:email?/:tab?/:code?',
  name: 'login',
  component: Login
}

const access: RouteConfig = {
  path: '/access',
  name: 'access',
  component: DashboardLayout,
  redirect: 'access/denied',
  children: [
    {
      path: 'denied',
      name: 'accessDenied',
      meta: {
        pageName: messages.common.access_closed
      },
      component: AccessDenied
    }
  ]
}

const isWidget = window.self !== window.top;

const routes: RouteConfig[] = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: isWidget ? undefined : '/settings/messengers'
  },
  {
    path: '*',
    name: 'notFound',
    component: DashboardLayout,
    redirect: '404',
    children: [
      {
        path: '404',
        meta: {
          pageName: messages.common.page_not_found
        },
        component: NotFound
      }
    ]
  },
  loginPage,
  notifications,
  settings,
  grades,
  resp,
  sched,
  wiki,
  messenger
]

export default routes